'use strict';

class RecurringList {
  constructor(recurringService, originatorService) {
    this.recurringService = recurringService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.active = [];
    this.inactive = [];

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });

    // sorting
    this.predicate = 'shipment.dates.next';
    this.reverse = true;
    this.order = (predicate) => {
      this.reverse = this.predicate === predicate ? !this.reverse : false;
      this.predicate = predicate;
    };

    this.recurringService.list()
      .then((resp) => {
        if (resp.status !== 204) {
          resp.data.forEach((i) => {
            if (i._links.start) {
              this.inactive.push(i);
            } else {
              this.active.push(i);
            }
          }, this);
        }
      });
  }

  formatShipment(string) {
    let i18n = {
      paper: 'Papir',
      email: 'E-post',
      ehf: 'EHF',
      agiro: 'Agiro',
      emailAndPaper: 'E-post og papir'
    };

    if (string in i18n) {
      return i18n[string];
    } else {
      return string;
    }
  }
}

RecurringList.$inject = ['recurringService', 'originatorService'];

const recurringList = {
  controller: RecurringList,
  template: `
    <div class="row">
      <div class="large-8 columns">
        <h2>Faste oppdrag</h2>
      </div>
      <div class="large-3 columns right-align">
        <a ng-show="$ctrl.originator && $ctrl.originator.giroLayout" role="button" href="#/fast-oppdrag/kladd" class="button">Nytt fast oppdrag</a>
        <a ng-show="$ctrl.originator && !$ctrl.originator.giroLayout" role="button" href="#/fast-oppdrag/utengiro/kladd" class="button">Nytt fast oppdrag</a>
      </div>
    </div>

    <div ng-if="!$ctrl.active.length && !$ctrl.inactive.length">
      Du har ingen faste oppdrag registrert
    </div>

    <div ng-if="$ctrl.active.length">
      <h3 class="subheader">Aktiv</h3>

      <table>
        <thead>
        <tr>
          <th></th>
          <th ng-click="$ctrl.order('name')" ng-class="{ sortorder: $ctrl.predicate === 'name', reverse: $ctrl.reverse }">Navn</th>
          <th ng-click="$ctrl.order('shipment.dates.next')" ng-class="{ sortorder: $ctrl.predicate === 'shipment.dates.next', reverse: $ctrl.reverse }">Neste utsendelse</th>
          <th>Bel&oslash;p</th>
          <th>Forsendelsesm&aring;te</th>
          <th>Kommentar</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="item in $ctrl.active | orderBy:$ctrl.predicate:$ctrl.reverse track by $index">
          <td><i ng-show="item.invoice.international" class="icon icon-flag-en left"></i></td>
          <td><a href="#/fast-oppdrag/{{ item.number }}">{{ item.name }}</a></td>
          <td>{{ item.shipment.dates.next | dateFormat }}</td>
          <td ng-if="'NOK' === item.invoice.currency">{{ item.invoice.total | crowns }}</td>
          <td ng-if="'NOK' !== item.invoice.currency">{{ item.invoice.total }} {{ item.invoice.currency }}</td>
          <td>{{ $ctrl.formatShipment(item.shipment.preferred) }}</td>
          <td>{{ item.comment }}</td>
          <td style="text-align:right">
              <a ng-show="item.invoice.international" href="#/regning/kladd/engelsk/ny?template={{ item.number }}" class="button secondary" role="button"><i class="fa fa-file"></i> Send som enkeltregning</a>
              <a ng-show="!item.invoice.international && item.invoice.giroLayout" href="#/regning/kladd/ny?template={{ item.number }}" class="button secondary" role="button"><i class="fa fa-file"></i> Send som enkeltregning</a>
              <a ng-show="!item.invoice.international && !item.invoice.giroLayout" href="#/regning/kladd/utengiro/ny?template={{ item.number }}" class="button secondary" role="button"><i class="fa fa-file"></i> Send som enkeltregning</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div ng-if="$ctrl.inactive.length">
      <h3 class="subheader">Inaktiv</h3>

      <table>
        <thead>
        <tr>
          <th></th>
          <th ng-click="$ctrl.order('name')" ng-class="{ sortorder: $ctrl.predicate === 'name', reverse: $ctrl.reverse }">Navn</th>
          <th>Bel&oslash;p</th>
          <th colspan="2">Kommenter</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="item in $ctrl.inactive | orderBy:$ctrl.predicate:$ctrl.reverse track by $index">
          <td><i ng-show="item.invoice.international" class="icon icon-flag-en left"></i></td>
          <td><a href="#/fast-oppdrag/{{ item.number }}">{{ item.name }}</a></td>
          <td ng-if="'NOK' === item.invoice.currency">{{ item.invoice.total | crowns }}</td>
          <td ng-if="'NOK' !== item.invoice.currency">{{ item.invoice.total }} {{ item.invoice.currency }}</td>

          <td colspan="2">{{ item.comment }}</td>
          <td style="text-align:right">
              <a ng-show="item.invoice.giroLayout" href="#/regning/kladd/ny?template={{ item.number }}" class="button secondary" role="button"><i class="fa fa-file"></i> Send som enkeltregning</a>
              <a ng-show="!item.invoice.giroLayout" href="#/regning/kladd/utengiro/ny?template={{ item.number }}" class="button secondary" role="button"><i class="fa fa-file"></i> Send som enkeltregning</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('recurringList', recurringList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/fast-oppdrag', {
        title: 'Fast oppdrag',
        template: '<recurring-list />',
        secure: true
      });
  });
